import React from "react";
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField} from "@mui/material";
import {Form, Formik} from "formik";
import * as Yup from "yup"; // For validation schema
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableCell from "@mui/material/TableCell";
import MDBox from "../../../../../../components/MDBox";
import MDTypography from "../../../../../../components/MDTypography";

const ExtraEarningsDialog = ({open, onClose, onSubmit, currentEarnings}) => {
    // Validation Schema for the Form
    const validationSchema = Yup.object().shape({
        amount: Yup.number()
            .typeError("Amount must be a number")
            .positive("Amount must be a positive value")
            .required("Amount is required"),
    });

    const initialValues = {
        amount: "",
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, actions) => {
                    onSubmit(values);
                    actions.resetForm();
                }}
            >
                {({values, errors, touched, handleChange, handleSubmit, isSubmitting}) => (
                    <Form onSubmit={handleSubmit}>
                        <DialogTitle>Manage Extra Earnings</DialogTitle>
                        <DialogContent>
                            <MDBox mb={2}>
                                <MDTypography variant="h6">Current Extra Earnings</MDTypography>
                                <TableContainer>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>Total Extra Earnings</TableCell>
                                                <TableCell align="right">${currentEarnings}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="h6" gutterBottom>
                                    Add Extra Earnings
                                </MDTypography>
                                <TextField
                                    id="amount"
                                    name="amount"
                                    label="Amount"
                                    fullWidth
                                    value={values.amount}
                                    onChange={handleChange}
                                    error={touched.amount && Boolean(errors.amount)}
                                    helperText={touched.amount && errors.amount}
                                    type="number"
                                    margin="normal"
                                />
                            </MDBox>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onClose} color="secondary">
                                Cancel
                            </Button>
                            <Button type="submit" color="primary" disabled={isSubmitting}>
                                Add Earnings
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default ExtraEarningsDialog;
